import React, { useState, useEffect, useMemo } from 'react';
import { Card, Form, Button, Row, Col, Badge, Spinner } from 'react-bootstrap';
import moment from 'moment';
import BonusService from '../../services/bonus.service';
import UserBonusesTable from '../../components/Bonuses/UserBonusesTable';
import { extractBonuses } from '../../utils/formatBonus';

const BonusesPage = () => {
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [allBonuses, setAllBonuses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    BonusService.GetBonuses({ startDate, endDate })
      .then((res) => {
        setAllBonuses(extractBonuses(res.data));
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  const handleFilter = (e) => {
    e.preventDefault();
  };

  return (
    <div className="container py-4">
      <h1 className="mb-4">My Bonuses</h1>
      <Card className="mb-4">
        <Card.Body>
          <Form onSubmit={handleFilter} as={Row} className="g-2 align-items-end">
            <Col md={4}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                max={endDate}
              />
            </Col>
            <Col md={4}>
              <Form.Label>End Date</Form.Label>
              <Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} min={startDate} />
            </Col>
            <Col md={4}>
              <Button type="submit" variant="primary">
                Filter
              </Button>
            </Col>
          </Form>
        </Card.Body>
      </Card>
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <Card>
          <Card.Body>
            <UserBonusesTable bonuses={allBonuses} showTotalRow={true} />
            {allBonuses.length === 0 && <div className="text-center py-4">No bonuses found</div>}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default BonusesPage;
